module.exports = __webpack_public_path__ + "img/file.ae9b79ac.svg";